// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "工程伦理",
      "tec": "毛云秀王若曦",
      "week": "1-8周",
      "add": "教学楼C座112教务"
    },
    {
      "sub": "化学电源工艺",
      "tec": "侯锦秋",
      "week": "1-12周",
      "add": "教学楼B座224自控"
    },
    {
      "sub": "现代分析测试技术",
      "tec": "唐坚柯昀洁",
      "week": "8-12周",
      "add": "教学楼C座302教务"
    },
    0,
    0
  ],
  "2": [
    {
      "sub": "现代分析测试技术",
      "tec": "唐坚柯昀洁",
      "week": "1-7周",
      "add": "教学楼D座120新能"
    },
    {
      "sub": "材料合成与制备",
      "tec": "张东",
      "week": "1,3,5,7,9周",
      "add": "教学楼D座121新能"
    },
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "就业创业指导",
      "tec": "赵明明李瀚林",
      "week": "1-5周",
      "add": "教学楼D座124新能"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "张洪涛",
        "week": "1-8周",
        "add": "教学楼B座425能动"
      },
      {
        "sub": "国家安全教育",
        "tec": "张洪涛",
        "week": "9-12周",
        "add": "教学楼B座425能动"
      }
    ],
    0,
    0,
    0
  ],
  "4": [
    0,
    {
      "sub": "材料合成与制备",
      "tec": "张东",
      "week": "1-11周",
      "add": "教学楼D座121新能"
    },
    [
      {
        "sub": "现代分析测试技术",
        "tec": "唐坚柯昀洁",
        "week": "1-7周",
        "add": "教学楼D座121新能"
      },
      {
        "sub": "现代分析测试技术",
        "tec": "唐坚柯昀洁",
        "week": "8-12周",
        "add": "教学楼D座121新能"
      }
    ],
    0,
    0
  ],
  "5": [
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "张洪涛",
        "week": "1-8周",
        "add": "教学楼A座117电力"
      },
      {
        "sub": "国家安全教育",
        "tec": "张洪涛",
        "week": "9-12周",
        "add": "教学楼A座117电力"
      }
    ],
    {
      "sub": "化学电源工艺",
      "tec": "侯锦秋",
      "week": "1-12周",
      "add": "教学楼A座317机械"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
